import styled from 'styled-components'

import theme from 'theme_'
import { CommonButton } from 'components/Button'
import { Font14, Font16 } from 'components/Typography'

export const MenuItems = styled.ul`
  margin: 0;
  padding: ${theme.spacing.xs} 0;
  list-style: none;
  background-color: ${theme.colors.white};
  box-shadow: 0px 4px 40px ${theme.colors.commonShadow};
  border-radius: 8px;
  min-width: 146px;
`

export const Button = styled(CommonButton)`
  height: 32px;
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  background-color: transparent;

  @media ${theme.devices.tablet} {
    height: 40px;
  }
`

export const ButtonTitle = styled.span`
  padding: 0 0 0 ${theme.spacing.xs};
  color: ${theme.colors.horizonOrange};
  ${Font14};

  @media ${theme.devices.tablet} {
    padding: 0 ${theme.spacing.base};
    ${Font16};
  }
`

export const Chevron = styled.span`
  display: none;
  align-items: center;
  justify-content: center;

  @media ${theme.devices.tablet} {
    display: flex;
  }
`
